 export default {
  apiKey: "AIzaSyAfM6sfs07NTzbJ6EvckdsfUMRIBK-Bc68",
  authDomain: "noblepath-ac2df.firebaseapp.com",
  databaseURL: "https://noblepath-ac2df-default-rtdb.firebaseio.com",
  projectId: "noblepath-ac2df",
  storageBucket: "noblepath-ac2df.appspot.com",
  messagingSenderId: "56853977136",
  appId: "1:56853977136:web:3b8de8a0a7e658e1f775f5",
  measurementId: "G-MSS587GQ3Y"
};
